export default "__VITE_ASSET__CUUF689k__"